import styled from 'styled-components';
import MuiButton from '@mui/material/Button';

const Button = styled(MuiButton)({
  '&&': {
    minWidth: 97,
    fontSize: 16,
    fontWeight: 900,
    borderRadius: 18,
    height: 44,
    boxSizing: 'border-box',
    letterSpacing: 0.1,
    textTransform: 'uppercase',
  },
});

export default Button;
